import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "../UserContext";

const Users = () => {
  const [userList, setUserList] = useState([]);
  const history = useHistory();

  const [user] = useContext(UserContext);
  const getUser = async () => {
    const UserList = await axios.get(
      "https://salt-neobank.herokuapp.com/get_user"
    );
    setUserList(UserList.data);
  };

  const addUser = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const email = data.get("email");
    const password = data.get("password");
    const name = data.get("name");
    await axios.post("https://salt-neobank.herokuapp.com/add_user", {
      email: email,
      password: password,
      name: name,
      acc_no: Math.floor(Math.random() * 8888888888888888 + 1000000000000000),
    });
    getUser();
  };

  useEffect(() => {
    if (user.role === "unauthenticated") {
      history.push("/");
    } else {
      getUser();
    }
  }, [history, user.role]);
  return (
    <Container>
      <Section>
        <h3>Add User</h3>
        <TransferForm onSubmit={(e) => addUser(e)}>
          <label htmlFor="email">Email</label>
          <input type="email" name="email" id="email" />
          <label htmlFor="password">Password</label>
          <input type="text" name="password" id="password" />
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="name" />
          <button type="submit">Add User</button>
        </TransferForm>
      </Section>
      <h3>Users List </h3>
      <Section>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Account Number</th>
              <th>Balance</th>
            </tr>

            {userList.map((e) => {
              return (
                <tr>
                  <td>{e.name}</td>
                  <td>{e.acc_no}</td>
                  <td>{e.balance}</td>
                </tr>
              );
            })}
          </thead>
        </table>
      </Section>
    </Container>
  );
};
const Container = styled.div`
  button {
    border-radius: 4px;
    padding: 0.5em;
    border: none;
    background-color: #f5642f;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
  }
`;
const TransferForm = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin: 0.5em 0;
  }
  input {
    padding: 0.5em;
    border: none;
    border-radius: 4px;
    :focus {
      outline: none;
      border: 1px solid #f5642f;
    }
  }
  button {
    border-radius: 4px;
    padding: 0.5em;
    border: none;
    background-color: #f5642f;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
  }
`;
const Section = styled.div`
  margin: 2em 0;
  td {
    padding: 0.5em;
    max-width: 300px;
    background: #ddd;
  }
  th {
    padding: 0.5em;
    background-color: #f5642f;
    color: white;
  }
`;
export default Users;
